<template>
  <div
    class="footer section"
    :style="sectionStyle"
  >
    <div class="container">
      <div class="flex justify-between items-center logo-links">
        <img
          v-if="logotypeImage"
          :src="logotypeImage"
          alt="logotypeImage"
          class="q-mr-md"
          height="50"
        >
        <div :class="['col flex items-center q-gutter-x-md', { [linksPosition]: linksPosition }]">
          <a
            v-for="(link, index) in items"
            :key="index"
            :style="linksStyle"
            :href="link.type === 'text' ? '#' : link.url"
            target="_blank"
            @click="link.type === 'text' ? openLink($event, link) : undefined"
          >
            {{ link.title }}
          </a>
        </div>
      </div>
      <div
        v-if="description"
        :style="descriptionStyle"
        class="text-center description"
        v-html="$options.filters.pureHtml(description)"
      />
    </div>
    <AppModal
      v-if="showContent"
      :title="selectedLink.title"
      content-class="preview-content fit"
      parent-class=""
      is-open
      show-close-btn
      @close="selectedLink = undefined"
    >
      <div class="row bg-white q-py-lg">
        <div class="col-6 offset-3">
          <div v-html="selectedLink.url"/>
        </div>
      </div>
    </AppModal>
  </div>
</template>

<script>
import AppModal from 'common/components/AppModal';
import backgroundMixin from './mixins/backgroundMixin';
import descriptionMixin from './mixins/descriptionMixin';

export default {
  name: 'FooterSection',
  components: { AppModal },
  mixins: [backgroundMixin, descriptionMixin],
  props: {
    logotypeImage: {
      type: String,
      default: undefined,
    },
    items: {
      type: Array,
      default: () => [],
    },
    linksFontColor: {
      type: String,
      default: '#FFFFFF',
    },
    linksFontSize: {
      type: Number,
      default: 14,
    },
    linksPosition: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      selectedLink: undefined,
    };
  },
  computed: {
    showContent() {
      return this.selectedLink !== undefined;
    },
    linksStyle() {
      return {
        color: this.linksFontColor,
        fontSize: `${this.linksFontSize}px`,
      };
    },
  },
  methods: {
    openLink(event, link) {
      event.preventDefault();
      this.selectedLink = link;
    },
  },
};
</script>

<style lang="scss">
.preview-content {
  border-radius: 0;

  .modal-header {
    background: white;
    position: sticky;
    top: 0;
    z-index: 1;
  }
}
</style>
